import axiosInstance from "../services/AxiosInstance"

const API_URL = "/trainerleaves"

export const getTrainerLeaves = async (limit = 10, page = 1, search = "", searchField = "") => {
  try {
    let url = `${API_URL}?limit=${limit}&page=${page}`;

    if (search && search.trim() !== "") {
      url += `&search=${encodeURIComponent(search)}`;
      if (searchField && searchField !== "all") {
        url += `&searchField=${searchField}`;
      }
    }

    const response = await axiosInstance.get(url);
    return {
      data: response.data.data,
      pagination: response.data.pagination,
    };
  } catch (error) {
    console.error("Error fetching trainer leaves", error);
    throw error;
  }
};

export const createTrainerLeave = async (leaveData) => {
  try {
    const response = await axiosInstance.post(API_URL, leaveData)
    return response.data
  } catch (error) {
    console.error("Error creating trainer leave", {
      error: error.response?.data,
      requestData: leaveData,
    })
    throw error
  }
}

export const updateTrainerLeave = async (leaveId, leaveData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/${leaveId}`, leaveData)
    return response.data
  } catch (error) {
    console.error("Error updating trainer leave", error)
    throw error
  }
}

export const deleteTrainerLeave = async (leaveId) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/${leaveId}`)
    return response.data
  } catch (error) {
    console.error("Error deleting trainer leave", error)
    throw error
  }
}

export const getTrainerLeaveById = async (leaveId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/${leaveId}`)
    return {
      data: response.data.data,
      status: response.status,
      message: response.data.message,
    }
  } catch (error) {
    console.error("Error fetching trainer leave details", error)
    throw error
  }
}
